import React from 'react';
import { 
  OwnerArrivalIndicator as JobOwnerArrivalIndicator, 
  OwnerDepartureIndicator as JobOwnerDepartureIndicator 
} from '../../job-indicators';

// Re-export the standardized indicators
export const OwnerArrivalIndicator = JobOwnerArrivalIndicator;
export const OwnerDepartureIndicator = JobOwnerDepartureIndicator;

// Helper functions to check if job has owner arrival/departure
export function isOwnerArrival(job) {
  return job.isOwnerArrival === true;
}

export function isOwnerDeparture(job) {
  return job.isOwnerDeparture === true;
} 